export default __webpack_public_path__ + "ec073d3898719a2b6983ac8c501ef1be.svg";